var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"AUserDeletedProfilePic"},[_c('slash-icon',{attrs:{"width":_vm.dims.width + 'px',"height":_vm.dims.height + 'px',"stroke-width":_vm.strokeWidth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }